const dateTimeFormatter = new Intl.DateTimeFormat("zh-CN", {
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
  hour: "2-digit",
  minute: "2-digit",
  hour12: false,
});

export function formatDateTime(value?: string) {
  if (!value) return "—";
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? "—" : dateTimeFormatter.format(date);
}

export function formatRelativeTime(value?: string) {
  if (!value) return "从未上线";
  const timestamp = new Date(value).getTime();
  if (Number.isNaN(timestamp)) return "未知";
  const elapsed = Date.now() - timestamp;
  if (elapsed < 60_000) return "刚刚";
  if (elapsed < 3_600_000) return `${Math.floor(elapsed / 60_000)} 分钟前`;
  if (elapsed < 86_400_000) return `${Math.floor(elapsed / 3_600_000)} 小时前`;
  return `${Math.floor(elapsed / 86_400_000)} 天前`;
}

export function formatTaskType(value: string) {
  const labels: Record<string, string> = {
    sync_contacts: "同步联系人",
    sync_chatrooms: "同步群聊",
    sync_call_logs: "同步通话记录",
    sync_sms: "同步短信",
    refresh_app_inventory: "刷新应用清单",
    check_social_status: "检查微信/企微状态",
    capture_accessibility_snapshot: "采集无障碍快照",
    enterprise_wechat_open: "拉起企业微信",
    capture_enterprise_wechat_snapshot: "采集企微快照",
    enterprise_wechat_send_message: "发送企微消息",
    rotate_device_token: "轮换设备 Token",
    upload_logs: "上传诊断日志",
  };
  return labels[value] || value;
}

export function formatRole(value?: string) {
  const labels: Record<string, string> = {
    tenant_admin: "租户管理员",
    operator: "运营人员",
    auditor: "审计员",
  };
  return value ? labels[value] || value : "未分配";
}
